import React, { useState, useEffect, useContext } from 'react';
import { supabase } from '../supabaseClient';
import { Box, TextField, Button, Typography, Paper, Alert, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ResetPassword = () => {
  const { user, logout, loading: authLoading } = useContext(AuthContext);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError('Wachtwoorden komen niet overeen');
      return;
    }
    
    if (password.length < 6) {
      setError('Wachtwoord moet minimaal 6 tekens lang zijn');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const { error: updateError } = await supabase.auth.updateUser({
        password: password,
      });

      if (updateError) throw updateError;
      
      // Log de gebruiker uit voordat we navigeren
      const { error: signOutError } = await supabase.auth.signOut();
      if (signOutError) {
        console.error('Sign out error after password reset:', signOutError);
        // Optioneel: een foutmelding tonen, hoewel de wachtwoord reset wel gelukt is
      }
      
      navigate('/login?passwordReset=success');
      
    } catch (err) {
      setError(err.message || 'Er is een fout opgetreden bij het opnieuw instellen van uw wachtwoord');
      console.error('Reset password error:', err);
      setLoading(false);
    }
  };

  if (authLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          Resetverzoek verifiëren...
        </Typography>
      </Box>
    );
  }

  if (!user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <Paper elevation={3} sx={{ p: 4, maxWidth: 500 }}>
          <Typography variant="h5" component="h1" gutterBottom>
            Wachtwoord Resetten
          </Typography>
          <Typography variant="body1" gutterBottom>
             Deze link is mogelijk ongeldig of verlopen, of u bent niet correct geauthenticeerd voor een wachtwoordreset.
          </Typography>
          <Typography variant="body1" gutterBottom>
             Als u uw wachtwoord opnieuw moet instellen, vraag dan een nieuwe link aan via de optie "Wachtwoord vergeten" op de inlogpagina.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/login')}
            sx={{ mt: 2 }}
          >
            Ga naar Inloggen
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400 }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Stel uw wachtwoord opnieuw in
        </Typography>
        
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Nieuw Wachtwoord"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
          <TextField
            label="Bevestig Wachtwoord"
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 3 }}
            disabled={loading}
          >
            {loading ? 'Bijwerken...' : 'Wachtwoord Bijwerken'}
          </Button>
          <Button
            variant="text"
            color="primary"
            fullWidth
            sx={{ mt: 1 }}
            onClick={() => navigate('/login')}
            disabled={loading}
          >
            Terug naar Inloggen
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ResetPassword;

